import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

import DataTable from "../../../../../controls/table/DataTable";
import AddIcon from "../../../../../../assets/img/add.png";
import EditIcon from "../../../../../../assets/img/Edit.png";
import DeleteIcon from "../../../../../../assets/img/Delete.png";
import EmptyPage from "../../../../../pages/EmptyPage";
import AddScoreRange from "./AddScoreRange";
import EditScoreRange from "./EditScoreRange";

import ContextComponent from "../../../../../AppContext";
import Utils from "../../../../../Utils";

const ScoreRange = () => {
  const { siteid } = useParams();

  const { setCanRedirectToLogin, setLoadingState, setAlert, userData } =
    useContext(ContextComponent);

  const [admin, setAdmin] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [moderator, setModerator] = useState(false);

  const [currSiteId] = useState(siteid);
  const [siteName, setSiteName] = useState("");

  const [scoreRangesGroup, setScoreRangesGroup] = useState(null);
  const [allScoreRanges, setAllScoreRanges] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableSelectedItems, setTableSelectedItems] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItemCount, setSelectedItemCount] = useState(0);

  const [editModalCanOpen, setEditModalCanOpen] = useState(false);
  const [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;

  const [editIconClass, setEditIconClass] = useState(DISABLED_ICON);

  const [tableColumns] = useState([
    "id",
    "groupSelect",
    "scoreRange",
    "resultTitle",
    "resultDescription",
    "colorCode",
  ]);

  const [tableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },

    groupSelect: {
      type: "groupRadio",
      title: "",
    },

    scoreRange: {
      type: "text",
      search: false,
      sort: false,
      title: "Score Range",
    },

    resultTitle: {
      type: "text",
      search: false,
      sort: false,
      title: "Result Title",
    },

    resultDescription: {
      type: "text",
      search: false,
      sort: false,
      title: "Result Description",
    },

    colorCode: {
      type: "color",
      search: false,
      sort: false,
      title: "Color",
    },
  });

  useEffect(() => {
    setAdmin(!!userData?.admin);
    setSuperAdmin(!!userData?.superAdmin);
    setModerator(userData?.roles?.includes("ROLE_MODERATOR") || false);
  }, [userData]);

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
    } else {
      setEditIconClass(DISABLED_ICON);
    }
  }, [tableSelectedItems]);

  const updateTableData = (ranges) => {
    setAllScoreRanges(ranges || []);

    const rows = (ranges || []).map((range) => {
      return [
        range.id,
        false,
        `${range.minScore} - ${range.maxScore}`,
        range.resultTitle || "",
        range.resultDescription || "",
        range.colorCode || "",
        range.displayOrder || 0,
      ];
    });
    setTableData(rows);
  };

  const loadFreshScoreRanges = () => {
    setLoadingState({
      applyMask: true,
      text: "Loading score ranges",
    });

    const fetchScoreRangeSuccess = (res) => {
      setLoadingState({
        applyMask: false,
      });

      const groups = res?.data || [];

      const currentGroup = groups.find(
        (group) => String(group?.siteId) === String(currSiteId),
      );
      setSiteName(currentGroup?.siteName || "");
      if (currentGroup) {
        setScoreRangesGroup(currentGroup);
        setTableSelectedItems([]);

        updateTableData(currentGroup.ranges || []);
      } else {
        setScoreRangesGroup(null);
        setAllScoreRanges([]);
        setTableData([]);
        setTableSelectedItems([]);
      }
    };

    const fetchScoreRangeFailure = (err) => {
      setLoadingState({
        applyMask: false,
      });

      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }

      console.log(err);
    };

    Utils.getAllScoreRanges().then(
      fetchScoreRangeSuccess,
      fetchScoreRangeFailure,
    );
  };

  useEffect(() => {
    loadFreshScoreRanges();
  }, [currSiteId]);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };

  const openEditModal = (e) => {
    e.preventDefault();

    if (tableSelectedItems.length !== 1 || !scoreRangesGroup?.id) {
      return;
    }

    setEditModalCanOpen(true);
  };

  const handleShow = () => {
    if (tableSelectedItems.length > 0) {
      setSelectedItemCount(tableSelectedItems.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  const deleteScoreRanges = () => {
    setShowDeleteModal(false);

    if (!scoreRangesGroup?.id) {
      return;
    }

    setLoadingState({
      applyMask: true,
      text: "Deleting score range",
    });

    const deleteSuccess = () => {
      setLoadingState({
        applyMask: false,
      });

      setAlert({
        show: true,
        message: "Score range(s) deleted successfully",
        type: "success",
      });

      setTableSelectedItems([]);

      loadFreshScoreRanges();
    };

    const deleteFailure = (err) => {
      setLoadingState({
        applyMask: false,
      });

      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }

      setAlert({
        show: true,
        message: err?.data?.message || "Score range deletion failed",
        type: "danger",
      });

      console.log(err);
    };
    Utils.deleteScoreRanges(scoreRangesGroup?.id).then(
      deleteSuccess,
      deleteFailure,
    );
  };

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        <span>
          Score Range{" "}
          <span className="indi-site-name-in-header">({siteName})</span>
        </span>

        <div className="d-none1 w-50 indi-body-actions">
          {(admin || superAdmin || moderator) && (
            <div
              className="indi-body-action"
              role="button"
              onClick={openAddModal}
            >
              <img className="indi-w-20" src={AddIcon} alt="add-icon" />
              Add
            </div>
          )}

          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon" />
            Edit
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="delete-icon" />
            Delete
          </div>
        </div>
      </div>

      {tableData.length > 0 ? (
        <DataTable
          minRows={0}
          tableProps={{
            tableColumns,
            tableColumnSchema,
            tableData,
            tableSelectedItems,
            setTableSelectedItems,
            groupSelectionId: scoreRangesGroup?.id,
          }}
        />
      ) : (
        <EmptyPage
          props={{
            emptyMessage: "No Score Ranges are available",
          }}
        />
      )}

      {addModalCanOpen && (
        <AddScoreRange
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            siteId: currSiteId,
            scoreRangesGroup,
            loadFreshScoreRanges,
          }}
        />
      )}

      {editModalCanOpen && (
        <EditScoreRange
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            siteId: currSiteId,
            scoreRangesGroup,
            existingRanges: allScoreRanges,
            loadFreshScoreRanges,
          }}
        />
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure to delete selected range group?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>

          <Button variant="primary" onClick={deleteScoreRanges}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ScoreRange;
